const TOKEN_KEY = 'bse2AuthToken';

export const authToken = () => localStorage.getItem(TOKEN_KEY) || '';

export const saveAuthToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const apiFetch = async (input, init = {}) => {
  const headers = new Headers(init.headers || {});
  const token = authToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const response = await fetch(input, { ...init, headers });
  if (response.status === 401 && token) {
    window.dispatchEvent(new CustomEvent('bse2-auth-expired'));
  }
  return response;
};

